import { render, staticRenderFns } from "./StatsShotDetails.vue?vue&type=template&id=5c2f4cb8&scoped=true&"
import script from "./StatsShotDetails.vue?vue&type=script&lang=js&"
export * from "./StatsShotDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatsShotDetails.vue?vue&type=style&index=0&id=5c2f4cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f4cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
